
import { useState, useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'
import axios from 'axios'

import { PhotoAlbum } from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

import 'bootstrap/dist/css/bootstrap.min.css'
import "yet-another-react-lightbox/styles.css";
import './App.css'

import { X } from 'react-bootstrap-icons';

import us from './img/us.jpg'
import oed from './img/oed.jpg'
import atletismo from './img/atletismo.jpg'
import entrenamiento from './img/entrenamiento.jpg'
import promo2026 from './img/promo2026.jpg'

import g1 from './img/competencias/g1.jpg'
import g2 from './img/competencias/g2.jpg'
import g3 from './img/competencias/g3.jpg'
import g4 from './img/competencias/g4.jpg'
import g5 from './img/competencias/g5.jpg'
import g6 from './img/competencias/g6.jpg'
import g7 from './img/competencias/g7.jpg'
import g8 from './img/competencias/g8.jpg'
import g9 from './img/competencias/g9.jpg'
import g10 from './img/competencias/g10.jpg'
import g11 from './img/competencias/g11.jpg'

import a1 from './img/atletismo/a1.jpeg'
import a2 from './img/atletismo/a2.jpeg'
import a3 from './img/atletismo/a3.jpeg'
import a4 from './img/atletismo/a4.jpeg'
import a5 from './img/atletismo/a5.jpeg'
import a6 from './img/atletismo/a6.jpeg'
import a7 from './img/atletismo/a7.jpeg'
import a8 from './img/atletismo/a8.jpeg'
import a9 from './img/atletismo/a9.jpeg'
import a10 from './img/atletismo/a10.jpeg'
import a11 from './img/atletismo/a11.jpeg'
import a12 from './img/atletismo/a12.jpeg'
import a13 from './img/atletismo/a13.jpeg'
import a14 from './img/atletismo/a14.jpeg'
import a15 from './img/atletismo/a15.jpeg'
import a16 from './img/atletismo/a16.jpeg'
import a17 from './img/atletismo/a17.jpeg'
import a18 from './img/atletismo/a18.jpeg'
import a19 from './img/atletismo/a19.jpeg'
import a20 from './img/atletismo/a20.jpeg'
import a21 from './img/atletismo/a21.jpeg'
import a22 from './img/atletismo/a22.jpeg'
import a23 from './img/atletismo/a23.jpeg'
import a24 from './img/atletismo/a24.jpeg'
import a25 from './img/atletismo/a25.jpeg'
import a26 from './img/atletismo/a26.jpeg'
import a27 from './img/atletismo/a27.jpeg'
import a28 from './img/atletismo/a28.jpeg'
import a29 from './img/atletismo/a29.jpeg'
import a30 from './img/atletismo/a30.jpeg'
import a31 from './img/atletismo/a31.jpeg'
import a32 from './img/atletismo/a32.jpeg'
import a33 from './img/atletismo/a33.jpeg'
import a34 from './img/atletismo/a34.jpeg'
import a35 from './img/atletismo/a35.jpeg'
import a36 from './img/atletismo/a36.jpeg'
import a37 from './img/atletismo/a37.jpeg'
import a38 from './img/atletismo/a38.jpeg'
import a39 from './img/atletismo/a39.jpeg'
import a40 from './img/atletismo/a40.jpeg'
import a41 from './img/atletismo/a41.jpeg'
import a42 from './img/atletismo/a42.jpeg'
import a43 from './img/atletismo/a43.jpeg'
import a44 from './img/atletismo/a44.jpeg'
import a45 from './img/atletismo/a45.jpeg'
import a46 from './img/atletismo/a46.jpeg'

const API_PATH = "https://somosglotones.com/srv/api/euk/sendChronosMail";
const SITE_KEY = "6LdaWaUrAAAAALkcZL5pXVO3CyzL6EPJE4QJLitE";

const photosGallery = [
  { src: g1, width: 705, height: 1600 },
  { src: g2, width: 960, height: 1280 },
  { src: g3, width: 960, height: 1280 },
  { src: g4, width: 1600, height: 1200 },
  { src: g5, width: 1200, height: 1600 },
  { src: g6, width: 1200, height: 1600 },
  { src: g7, width: 1200, height: 1600 },
  { src: g8, width: 1600, height: 1200 },
  { src: g9, width: 1600, height: 1200 },
  { src: g10, width: 1600, height: 1262 },
  { src: g11, width: 1200, height: 1600 }
]

const photosAtletismo = [
  { src: a1, width: 1600, height: 1066 },
  { src: a2, width: 1600, height: 1066 },
  { src: a3, width: 1600, height: 1066 },
  { src: a4, width: 1600, height: 1066 },
  { src: a5, width: 1600, height: 1066 },
  { src: a6, width: 1600, height: 1066 },
  { src: a7, width: 1600, height: 1066 },
  { src: a8, width: 1600, height: 1066 },
  { src: a9, width: 1600, height: 1066 },
  { src: a10, width: 1600, height: 1066 },
  { src: a11, width: 1600, height: 1066 },
  { src: a12, width: 1600, height: 1066 },
  { src: a13, width: 1600, height: 1066 },
  { src: a14, width: 1600, height: 1066 },
  { src: a15, width: 1600, height: 1066 },
  { src: a16, width: 1600, height: 1066 },
  { src: a17, width: 1066, height: 1600 },
  { src: a18, width: 1600, height: 1066 },
  { src: a19, width: 1066, height: 1600 },
  { src: a20, width: 1600, height: 1066 },
  { src: a21, width: 1600, height: 1066 },
  { src: a22, width: 1600, height: 1066 },
  { src: a23, width: 1600, height: 1066 },
  { src: a24, width: 1600, height: 1066 },
  { src: a25, width: 1600, height: 1066 },
  { src: a26, width: 1066, height: 1600 },
  { src: a27, width: 1600, height: 1066 },
  { src: a28, width: 1600, height: 1066 },
  { src: a29, width: 1066, height: 1600 },
  { src: a30, width: 1066, height: 1600 },
  { src: a31, width: 1066, height: 1600 },
  { src: a32, width: 1600, height: 1066 },
  { src: a33, width: 1600, height: 1066 },
  { src: a34, width: 1600, height: 1066 },
  { src: a35, width: 1600, height: 1066 },
  { src: a36, width: 1600, height: 1066 },
  { src: a37, width: 1600, height: 1066 },
  { src: a38, width: 1600, height: 1066 },
  { src: a39, width: 1600, height: 1066 },
  { src: a40, width: 1600, height: 1066 },
  { src: a41, width: 1600, height: 1066 },
  { src: a42, width: 1066, height: 1600 },
  { src: a43, width: 1066, height: 1600 },
  { src: a44, width: 1066, height: 1600 },
  { src: a45, width: 1066, height: 1600 },
  { src: a46, width: 1600, height: 1066 },
]

function Home({ refHome, refUs, refServices, refContact, handleClick }) {
  const [isLoading, setLoading] = useState(false)
  const [firstName, setFirstName] = useState("")
  const [name, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [key, setKey] = useState('competencias');

  const [showPromo, setShowPromo] = useState(true)

  const [lightIndex, setLightIndex] = useState(-1)
  const [lightIndex2, setLightIndex2] = useState(-1)

  const handleShow = () => setShowMessage(true);

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleOnChange = (event) => {
    var inputName = "set" + event.target.name.charAt(0).toUpperCase() + event.target.name.slice(1);
    eval(inputName)(event.target.value)
  }

  const handleOnSubmit = (event) => {
    event.preventDefault();

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        //if(isVerified){
        setLoading(true);
        //const recaptchaValue = recaptchaRef.current.getValue();
        var form = document.getElementById("contactForm");
        var formData = new FormData(form);
        formData.append('name', firstName + " " + lastName);
        formData.append('recaptcha_response', token);

        setLoading(true);
        axios.post(API_PATH, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {

          if (response.data == "FAIL" || response.data == "ERROR") {
            setLoading(false)
            setTitle("Error")
            setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
            handleShow()
          } else {
            setLoading(false)
            setTitle("Mensaje enviado")
            setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
            handleShow()

            setName("");
            setFirstName("")
            setLastName("")
            setPhone("");
            setEmail("");
            setComments("");
          }

        }).catch(function (err) {
          setLoading(false)
          setTitle("Error")
          setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
          handleShow()
        });
        //} else 
        //alert("Por favor, verifica que no eres un robot")
      });
    });
  }

  return (
    <div>
      <Modal show={showMessage} onHide={() => setShowMessage(false)}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{message}</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button aria-label="Aceptar" variant="secondary" onClick={() => setShowMessage(false)}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPromo} onHide={() => setShowPromo(false)} centered className='promo-modal'>
        <div align="right" onClick={() => setShowPromo(false)}> <X className='promo-x' /> </div>
        <a href="/sinexcusas">
          <div> <img src={promo2026} className='promo-float' /> </div>
        </a>
      </Modal>

      <div className='banner-container' ref={refHome}>
        <Container>
          <Row>
            <Col md={7} xs={12}>
              <div className='home-title'><span className='home-capital'>S</span>uperación</div>
              <div className='home-title'><span className='home-capital'>E</span>sfuerzo</div>
              <div className='home-title'><span className='home-capital'>R</span>esponsabilidad</div>
              <br /><br />
              <div className='home-text-container'>
                <div className='home-desc'> “La calidad de la vida de una persona es directamente proporcional a su compromiso con la excelencia" </div>
                <div className='home-desc home-author'> -- Vince Lombardi </div>
              </div>
            </Col>
            <Col></Col>
          </Row>
        </Container>
      </div>

      <div className='section-white' ref={refUs}>
        <Container>
          <Row className='align-items-center'>
            <Col md={6}>
              <div className='us-container'>
                <img src={us} className='us-image' />
              </div>
            </Col>
            <Col md={6}>
              <div className='us-container'>
                <div className='us-title'>¿Quiénes Somos?</div>
                <br />
                <div className='us-desc'> Con 15 años de experiencia en el ámbito de la Educación Física y el Atletismo, nuestro objetivo es impulsar el potencial de diferentes empresas, instituciones y personas de todas las edades a través del deporte, el entrenamiento y la organización de eventos deportivos corporativos y públicos. </div>
                <br />
                <div align={isMobile ? 'center' : "right"}>
                  <div className='us-button' onClick={() => handleClick('refContact')}>
                    ¡Contáctanos!
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section-gray' ref={refServices}>
        <Container>
          <Row className='align-items-center'>
            <Col md={6}>
              <div className='us-container'>
                <div className='us-title text-white'>Nuestros Servicios</div>
                <br />
                <div className='us-desc text-white'> Nos comprometemos a brindar un servicio de excelencia, basado en la responsabilidad, calidad y confianza. Porque nuestro principal objetivo, es la satisfacción de nuestros clientes. </div>
                <br />
              </div>
            </Col>
            <Col md={6}>
              <div className='service-container'>
                <div className="image-card" style={{ backgroundImage: 'url(' + oed + ')' }}>
                  {/*<img src={imageSrc} alt="Organización de eventos deprtivos" className="image-card-img" />*/}
                  <div className="image-card-title">Organización de eventos deportivos</div>
                  <div className="image-card-overlay">
                    <div className='image-card-container'>
                      <div className="image-card-text-title"> Organización de eventos deportivos </div>
                      <br />
                      <div className="image-card-text">Corporativos, institucionales, carreras atléticas, circuitos deportivos, torneos, competencias.</div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className='service-container'>
                <div className="image-card" style={{ backgroundImage: 'url(' + atletismo + ')' }}>
                  {/*<img src={imageSrc} alt="Organización de eventos deprtivos" className="image-card-img" />*/}
                  <div className="image-card-title">CLUB DE ATLETISMO</div>
                  <div className="image-card-overlay">
                    <div className='image-card-container'>
                      <div className="image-card-text-title"> CLUB DE ATLETISMO </div>
                      <br />
                      <div className="image-card-text">Comparte tu pasión por correr con nosotros. Entre nuestras filas hay niños (desde los 6 años, adolescentes y adultos)</div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className='service-container'>
                <div className="image-card" style={{ backgroundImage: 'url(' + entrenamiento + ')' }}>
                  {/*<img src={imageSrc} alt="Organización de eventos deprtivos" className="image-card-img" />*/}
                  <div className="image-card-title">ENTRENAMIENTO PERSONAL</div>
                  <div className="image-card-overlay">
                    <div className='image-card-container'>
                      <div className="image-card-text-title"> ENTRENAMIENTO PERSONAL </div>
                      <br />
                      <div className="image-card-text">Haz realidad tu sueño transformando tu cuerpo con un plan disenado exclusivamente para ti.</div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section-yellow'>
        <div align="center">
          <div className='frase'>
            “Ganar significa que estas dispuesto a ir más lejos, trabajar más duro y dar más que cualquier otra persona”
            <br />
            <div style={{ fontStyle: 'italic' }}>--Vince Lombardi</div>
          </div>
        </div>
      </div>

      <div className='section-contact' ref={refContact}>
        <div align="center">
          <div className='us-title' style={{ textAlign: 'center' }}>CONTACTO</div>
          <br />
          <div className='us-desc' style={{ textAlign: 'center' }}>Ingresa tus datos de contacto y uno de nuestros agentes se comunicará contigo a la brevedad</div>

          <div className='form-container'>
            <Form id="contactForm" onSubmit={handleOnSubmit}>
              <Container>
                <Row>
                  <Col md={6} xs={12}>
                    <Form.Group controlId="formGridEmail" className='mb-3'>
                      <Form.Control required name="firstName" value={firstName} placeholder="Nombre:" onChange={handleOnChange} />
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={12}>
                    <Form.Group controlId="formGridEmail" className='mb-3'>
                      <Form.Control required name="lastName" value={lastName} placeholder="Apellido:" onChange={handleOnChange} />
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={12}>
                    <Form.Group controlId="formGridEmail" className='mb-3'>
                      <Form.Control required type="number" value={phone} name="phone" placeholder="Teléfono:" onChange={handleOnChange} />
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={12}>
                    <Form.Group controlId="formGridEmail" className='mb-3'>
                      <Form.Control required type="email" value={email} name="email" placeholder="Correo Electrónico:" onChange={handleOnChange} />
                    </Form.Group>
                  </Col>
                  <Col md={12} xs={12}>
                    <Form.Group controlId="formGridEmail" className='mb-3'>
                      <Form.Control required name="comments" as="textarea" value={comments} rows="4" placeholder="Mensaje:" onChange={handleOnChange} />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <div>
                    <br />
                    <div align="center"><Button aria-label="Enviar" disabled={isLoading} className="form-button" type="submit" >{isLoading ? 'Enviando…' : 'ENVIAR'}</Button></div>
                  </div>
                </Row>
              </Container>
            </Form>
          </div>
        </div>
        <br /><br /><br />

        <div className='us-title' style={{ textAlign: 'center' }}>GALERÍA</div>
        <br />
        <Container>
          <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3 justify-content-center"
          >
            {/*<Tab eventKey="carrera" title="Carrera Familiar 2025">
              <PhotoAlbum className='bg-album' layout="columns" photos={photosGallery} columns={isMobile ? 2 : 5} onClick={({ index }) => setLightIndex(index)} />

              <Lightbox
                slides={photosGallery}
                open={lightIndex >= 0}
                index={lightIndex}
                close={() => setLightIndex(-1)}
                // enable optional lightbox plugins
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
              />
            </Tab>*/}
            <Tab eventKey="competencias" title="Competencias y Eventos Deportivos">
              <PhotoAlbum className='bg-album' layout="columns" photos={photosGallery} columns={isMobile ? 2 : 5} onClick={({ index }) => setLightIndex(index)} />

              <Lightbox
                slides={photosGallery}
                open={lightIndex >= 0}
                index={lightIndex}
                close={() => setLightIndex(-1)}
                // enable optional lightbox plugins
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
              />
            </Tab>
            <Tab eventKey="atletismo" title="Entrenamiento de Atletismo">
              <PhotoAlbum className='bg-album' layout="columns" photos={photosAtletismo} columns={isMobile ? 2 : 5} onClick={({ index }) => setLightIndex2(index)} />

              <Lightbox
                slides={photosAtletismo}
                open={lightIndex2 >= 0}
                index={lightIndex2}
                close={() => setLightIndex2(-1)}
                // enable optional lightbox plugins
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
              />
            </Tab>
          </Tabs>
        </Container>
      </div>

    </div>
  );
}

export default Home;